<template>
    <div class="order">
        <div class="search m-b-20">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入关键字搜索" v-model="value" type="text">
            </div>
        </div>
        <ul class="orderList" >
            <li class="item m-b-20" v-for="(item, index) in orderList" :key="index" @click="viewPage(item)">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：{{item.orderNumber}}</p>
                </div>
                <div class="product m-t-25">合同号：{{item.contractSerialNumber}}</div>
                <div class="products m-t-25 flex-row" v-if="item.type == 2">
                    <p>合同原价：{{item.goodsOriginalPrice}}</p>
                    <p class="invoice">优惠金额：{{item.goodsOriginalPrice - item.contractMoney}}</p>
                </div>
                <div class="product border-bottom p-b-20 m-t-20">合同金额：{{item.contractMoney}}</div>
                <div class="product flex-row m-t-20">
                    <p>产品类别：{{item.categoryName}}</p>
                </div>
                <div class="product m-t-25">所属门店：{{item.storeName}} </div>
                <div class="products m-t-25 flex-row m-b-20">
                    <p>客户负责人：<span>{{item.salesmanName}}</span></p>
                    <span class="invoice">手机:{{item.salesmanPhone}}</span>
                </div>
                <div class="products m-t-25 flex-row m-b-20">
                    <p>设计师：<span>{{item.designerName}}</span></p>
                    <span class="invoice">手机:{{item.designerPhone}}</span>
                </div>
                <div class="products m-t-25 flex-row m-b-20">
                    <p>签订时间：<span>{{item.signingTime.slice(0,10)}}</span></p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import product from '@/assets/img/product.jpg';
import tel from '@/assets/img/tel.png';
import { listOrderContract } from '@/api/index';
import receiving from '@/assets/img/收货@3x.png';
export default {
    data(){
        return {
            search,
            product,
            tel,
            value:'',
            orderList:[],
            item:{

            }
        }
    },
    created(){
        this.$loca.setItem('routeItem', this.$route.path);
        this.getData();
    },
    methods:{
        viewPage(item){
            this.$router.push({path:'viewPdfs',query:{item: JSON.stringify(item)}});
        },
        /**
         * 获取订单列表
         * @method getData
         */
        getData(){
            let data = this.$loca.getItem('phone');
            let name = this.$loca.getItem('name');
            listOrderContract({phone: data,orderNumber: this.value ,  contractType: 1, name: name}).then(res => {
                this.orderList = res.data;
            }).catch(error => {
                console.log('获取合同列表 views/appointment/list.vue');
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.order{
    background: $color-ed;
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
    .orderList{
        background: $color-ed;
        .item{
            // height: 334px;
            background: $ffff;
            padding: 0 20px;
            padding-bottom: 10px;
            .title{
                padding: 18px 0 15px 0; 
                justify-content: space-between;
                .orderNumber{
                    font-size:28px;
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                }
                .orderStats{
                    font-size:20px;
                    color:rgba(86,180,240,1);
                    margin-right: 11px;
                    span{
                        margin-left: 15px;
                    }
                }
            }
            .product{
                padding-left: 14px;
                font-size:24px;
                color: $color-102;
                justify-content: space-between;
                align-items: center;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-153;
                }
            }
            .products{
                margin-left: 14px;
                font-size:24px;
                color: $color-102;
                align-items: center;
                position: relative;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    position: absolute;
                    left: 350px;
                }
            }
            .info{
                padding: 16px 0 10px 0;
                font-size:24px;
                color:$color-153;
                width: auto;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 54px;
                    height: 54px;
                }
                .information{
                    align-items:center;
                    .names{
                        margin-bottom: 7px;
                    }
                    img{
                        width: 65px;
                        height: 65px;
                        margin: 0 25px 0 21px;
                    }
                }
            }
        }
    }
}
.border-bottom{
    border-bottom:2px solid rgba(229,229,229,1);
}
.delivery{
    color:$color-162;
}
</style>

